import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import moment from 'moment'
import MonthYearPicker from './MonthYearPicker'
import './MonthPicker.sass'

class MonthYearPickerRange extends Component {
  disabledFromMonths = (month, year) => {
    const { monthYearTo } = this.props
    if (moment(monthYearTo) < moment(new Date(`${year}-${month}`))) {
      return true
    }
    return false
  }

  disabledToMonths = (month, year) => {
    const { monthYearFrom } = this.props
    if (moment(monthYearFrom) > moment(new Date(`${year}-${month}`))) {
      return true
    }
    return false
  }

  render() {
    const {
      fromError,
      toError,
      monthYearFrom,
      monthYearTo,
      onFromChange,
      onToChange,
      onFromBlur,
      onToBlur,
      disableFrom,
      disableTo,
      disabled
    } = this.props
    return (
      <div className='datepicker__range month'>
        <MonthYearPicker
          monthAndYear={monthYearFrom}
          onChange={monthAndYear => {
            onFromChange(monthAndYear)
          }}
          error={fromError}
          isMonthDisabled={(month, year) => {
            return this.disabledFromMonths(month, year)
          }}
          onBlur={onFromBlur}
          disabled={disabled || disableFrom}
        />
        <span className='datepicker__separator'>—</span>
        <MonthYearPicker
          monthAndYear={monthYearTo}
          onChange={monthAndYear => {
            onToChange(monthAndYear)
          }}
          error={toError}
          onBlur={onToBlur}
          isMonthDisabled={(month, year) => {
            return this.disabledToMonths(month, year)
          }}
          disabled={disabled || disableTo}
        />
      </div>
    )
  }
}

MonthYearPickerRange.propTypes = {
  fromError: PropTypes.string,
  toError: PropTypes.string,
  onFromChange: PropTypes.func,
  onToChange: PropTypes.func,
  onFromBlur: PropTypes.func,
  onToBlur: PropTypes.func,
  monthYearFrom: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  monthYearTo: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  disableFrom: PropTypes.bool,
  disableTo: PropTypes.bool,
  disabled: PropTypes.bool
}

export default observer(MonthYearPickerRange)
